import { useEffect } from "react";
export const useDocumentTitle = (title) => {

    useEffect(() => {
        document.title = `${title} » Werk in het Vooruitzicht`;
    }, [title]);

    return null;
}